export default __webpack_public_path__ + "static/media/Logo-xsmall.f6727867.svg";